import React from "react";
import { FieldError } from "react-hook-form";

interface ErrorProps {
  error?: FieldError;
  errorMessage?: string;
}

const ErrorComponent: React.FC<ErrorProps> = ({ error, errorMessage }) => {
  if (!error) return null;

  const getErrorMessage = () => {
    switch (error?.type) {
      case "required":
        return "This filed is required";

      case "min":
        return "Minimum value is";
      case "max":
        return "Maximum value is";

      case "minLength":
        return "Minimum characters count is";

      case "maxLength":
        return "Maximum characters count is";

      default:
        return errorMessage || "";
    }
  };

  return (
    <div
      id="general-text"
      style={{
        color: "#D92D20",
        fontSize: "14px",
      }}
    >
      {getErrorMessage()}
    </div>
  );
};

export default ErrorComponent;
